import { t } from "i18next";
import ERPSBaseLink from "../components/custom/inputs/ERPSBaseLink";

export const EMPTY_BILLER_CROSS_REF_CRITERIA = {
  centralizedBillerId: "",
  bmoBillerId: "",
  bnsBillerId: "",
  cibcBillerId: "",
};

export const MANAGE_BILLER_CROSS_REF_PROFILE_BASE =
  "/manage-biller-cross-reference";

export const getBillerCrossReferenceGridHeadings = ({
  listComponentAccess = [],
  profilePathBase = MANAGE_BILLER_CROSS_REF_PROFILE_BASE,
} = {}) => [
  {
    field: "centralizedBillerId",
    headerName: t("erps.billermanagement.crossreference.label.centralizedBillerId"),
    width: 200,
    sortable: false,
    renderCell: (params) => {
      const raw = params.value;
      if (raw == null || String(raw).trim() === "") {
        return "";
      }
      const id = String(raw).trim();
      return (
        <ERPSBaseLink
          to={{
            pathname: `${profilePathBase}/biller-profile`,
            state: {
              centralizedBillerId: id,
              displayBillerId: id,
              componentAccess: listComponentAccess,
              bcrRow: { ...params.row },
              fromDetailPage: true,
            },
          }}
          className="link__blue"
          label={id}
          actionType="hasSearchBillerCrossReferenceAccess"
          componentAccess={listComponentAccess}
        />
      );
    },
  },
  {
    field: "bmoBillerId",
    headerName: t("erps.billermanagement.crossreference.label.bmoBillerId"),
    width: 200,
    sortable: false,
  },
  {
    field: "bnsBillerId",
    headerName: t("erps.billermanagement.crossreference.label.bnsBillerId"),
    width: 200,
    sortable: false,
  },
  {
    field: "cibcBillerId",
    headerName: t("erps.billermanagement.crossreference.label.cibcBillerId"),
    width: 200,
    sortable: false,
  },
];
